<mui-icon [font]="iconFont" [name]="icon" class="mui-hero-action-button__icon"></mui-icon>
